import React from 'react';
import { Button, Modal, ModalVariant } from '@patternfly/react-core';
import {
  RegressionTestSuiteSelection,
  RegressionTestSuiteSelector,
} from './RegressionTestSuiteSelector';

interface RegressionTestConfigModalProps {
  isOpen: boolean;
  onClose: () => void;
  selections: Record<string, RegressionTestSuiteSelection>;
  onChange: (next: Record<string, RegressionTestSuiteSelection>) => void;
}

export const RegressionTestConfigModal: React.FC<RegressionTestConfigModalProps> = ({
  isOpen,
  onClose,
  selections,
  onChange,
}) => {
  return (
    <Modal
      title="Regression Test Configuration"
      variant={ModalVariant.medium}
      isOpen={isOpen}
      onClose={onClose}
      actions={[
        <Button key="done" variant="primary" onClick={onClose}>
          Done
        </Button>,
      ]}
    >
      <RegressionTestSuiteSelector selections={selections} onChange={onChange} />
    </Modal>
  );
};
